import * as api from './api'
import * as reducers from './slice-reducers'
import { AppDispatch } from 'src/app/store'
import {
  AdminSaleOfferGroup,
  MakeCounterOfferPayload,
  SaleOfferApiPayload,
  SaleOfferGroup,
  UserSaleOffer
} from 'src/core/models'

export const getAllSaleOfferGroups = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setAllSaleOffersGroupValue({ key: 'loading', value: true }))
    const data: AdminSaleOfferGroup[] = await api.getAllSaleOfferGroupsAPI()
    dispatch(reducers.setAllSaleOffersGroupValue({ key: 'data', value: data }))
    dispatch(reducers.setAllSaleOffersGroupValue({ key: 'loading', value: false }))
  } catch (error) {
    dispatch(reducers.resetAllSalesOfferState())
  }
}

export const getSaleOfferGroups = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setSaleOffersGroupValue({ key: 'loading', value: true }))
    const data: SaleOfferGroup[] = await api.getSaleOfferGroupsAPI()
    dispatch(reducers.setSaleOffersGroupValue({ key: 'data', value: data }))
    dispatch(reducers.setSaleOffersGroupValue({ key: 'loading', value: false }))
  } catch (error) {
    dispatch(reducers.setSaleOffersGroupValue({ key: 'loading', value: false }))
  }
}

export const createSaleOfferGroup = (name: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setSaleOffersGroupValue({ key: 'creatingLoading', value: true }))
    await api.createSaleOfferGroupsAPI({ name })
    dispatch(reducers.setSaleOffersGroupValue({ key: 'successCreate', value: true }))
    dispatch(getSaleOfferGroups())
    dispatch(reducers.setSaleOffersGroupValue({ key: 'creatingLoading', value: false }))
  } catch (error) {
    if (error?.response?.data?.name) {
      dispatch(reducers.setSaleOffersGroupValue({ key: 'errorCreate', value: true }))
    }
    dispatch(reducers.setSaleOffersGroupValue({ key: 'creatingLoading', value: false }))
    dispatch(reducers.setSaleOffersGroupValue({ key: 'successCreate', value: false }))
  }
}

export const filterSaleOfferProject = (
  value: string | number, filterType: 'name' | 'id'
) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setSaleOfferFilterProjectValue({ key: 'loading', value: true }))
    const projectFiltered = await api.filterSaleOfferProjectAPI(value, filterType)
    dispatch(reducers.setSaleOfferFilterProjectValue({ key: 'data', value: projectFiltered }))
    dispatch(reducers.setSaleOfferFilterProjectValue({ key: 'loading', value: false }))
    dispatch(reducers.setSaleOfferFilterProjectValue({ key: 'notFound', value: false }))
  } catch (error) {
    if (error?.response?.data?.detail === 'Project not found.') {
      dispatch(reducers.setSaleOfferFilterProjectValue({ key: 'notFound', value: true }))
    }
    dispatch(reducers.setSaleOfferFilterProjectValue({ key: 'loading', value: false }))
  }
}


export const createSaleOffer = (payload: SaleOfferApiPayload) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setCreateSaleOfferValue({ key: 'loading', value: true }))
    await api.createSaleOfferAPI(payload)
    dispatch(reducers.setCreateSaleOfferValue({ key: 'success', value: true }))
    dispatch(reducers.setCreateSaleOfferValue({ key: 'loading', value: false }))
  } catch (error) {
    dispatch(reducers.setCreateSaleOfferValue({ key: 'success', value: false }))
    dispatch(reducers.setCreateSaleOfferValue({ key: 'loading', value: false }))
  }
}

export const getUserSaleOffers = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setUserSaleOffersValue({ key: 'loading', value: true }))
    const saleOffers = await api.getUserSaleOffersAPI()
    dispatch(reducers.setUserSaleOffersValue({ key: 'data', value: saleOffers }))
    dispatch(reducers.setUserSaleOffersValue({ key: 'loading', value: false }))
  } catch (error) {
    dispatch(reducers.setUserSaleOffersValue({ key: 'data', value: [] }))
    dispatch(reducers.setUserSaleOffersValue({ key: 'loading', value: false }))
  }
}

export const getUserSaleOfferDetails = (offerId: number) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setSaleOfferDetailsValue({ key: 'currenctOfferId', value: offerId }))
    dispatch(reducers.setSaleOfferDetailsValue({ key: 'loading', value: true }))
    const saleOffer = await api.getUserSaleOfferDetailsAPI(offerId)
    dispatch(reducers.setSaleOfferDetailsValue({ key: 'saleOffer', value: saleOffer }))
    dispatch(reducers.setSaleOfferDetailsValue({ key: 'loading', value: false }))
  } catch (error) {
    dispatch(reducers.resetSaleOfferDetailsState())
  }
}

export const acceptUserSaleOffer = (offerId: number) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setAcceptSaleOfferValue({ key: 'currenctOfferId', value: offerId }))
    dispatch(reducers.setAcceptSaleOfferValue({ key: 'loading', value: true }))
    await api.acceptUserSaleOfferAPI(offerId)
    dispatch(reducers.updateSaleOfferStatusOnList({ offerId, status: 'accepted' }))
    dispatch(reducers.setAcceptSaleOfferValue({ key: 'success', value: true }))
    dispatch(reducers.setAcceptSaleOfferValue({ key: 'loading', value: false }))
  } catch (error) {
    dispatch(reducers.resetAcceptSaleOfferState())
  }
}

export const rejectUserSaleOffer = (offerId: number) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setRejectSaleOfferValue({ key: 'currenctOfferId', value: offerId }))
    dispatch(reducers.setRejectSaleOfferValue({ key: 'loading', value: true }))
    await api.rejectUserSaleOfferAPI(offerId)
    dispatch(reducers.updateSaleOfferStatusOnList({ offerId, status: 'rejected' }))
    dispatch(reducers.setRejectSaleOfferValue({ key: 'success', value: true }))
    dispatch(reducers.setRejectSaleOfferValue({ key: 'loading', value: false }))
  } catch (error) {
    dispatch(reducers.resetRejectSaleOfferState())
  }
}

export const makeCounterSaleOffer = (
  offerId: number, payload: MakeCounterOfferPayload
) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setCounterSaleOfferValue({ key: 'currenctOfferId', value: offerId }))
    dispatch(reducers.setCounterSaleOfferValue({ key: 'loading', value: true }))
    const newOffer: UserSaleOffer = await api.makeCounterSaleOfferAPI(offerId, payload)
    dispatch(reducers.updateSaleOfferStatusOnList({ offerId, status: 'rejected' }))
    dispatch(reducers.addNewSaleOffer(newOffer))
    dispatch(reducers.setCounterSaleOfferValue({ key: 'success', value: true }))
    dispatch(reducers.setCounterSaleOfferValue({ key: 'loading', value: false }))
  } catch (error) {
    dispatch(reducers.resetCounterSaleOfferState())
  }
}
